module.exports = __webpack_public_path__ + "media/images/logo-white-240x60-67dbd236f5535ef844158b9ccb75567e.png";